import { Button, Form, message, Modal,notification } from "antd";
import { useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import ExpenseTypeForm from "./depensetype-Form";
import useExpenseTypes from "hooks/useExpenseTypes";
import dayjs from "dayjs";


const EditExpenseTypeModal = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType,modalProps } = useSelector((state) => state.modals);
  const { getExpenseById: getExpenseTypeById, updateExpense: updateExpenseType,getAllExpenseTypes,Expense, setExpense, isLoading, error, setError } = useExpenseTypes();
const [isSendForUpdate, setIsSendForUpdate] = useState(false);
useEffect(() => {
  if (modalProps?.expenseTypeId) {
    const loadData = async () => {
      try {
        await getExpenseTypeById(modalProps.expenseTypeId);
      } catch (error) {
        message.error(t("expenseTypes.load.error"));
      }
    };
    loadData();
  }
}, [modalProps?.expenseTypeId]);

useEffect(() => {
  if (Expense) {
    form.setFieldsValue({
      type: Expense.type,
      description: Expense.description
    });
  }
}, [Expense, form]);

  useEffect(() => {
          if (isSendForUpdate) {
              if (error) {
                  message.error(
                      t("employees.crud.form.error.edit") + " " + error
                  )
              } else {
                  message.success(
                      t("employees.crud.form.edit.success")
                  )
                  onClose();
              }
              setIsSendForUpdate(false);
          }
      }, [isSendForUpdate, error]);

      const open = isModalOpen && modalType === "edit_expense_type";


  // useEffect(() => {
  //   if (currentExpenseType) {
  //     form.setFieldsValue(currentExpenseType);
  //   }
  // }, [currentExpenseType]);

  const onSubmit = async (values) => {
    setError(null);
        setIsSendForUpdate(false);
    try {
      await updateExpenseType(values,modalProps?.expenseTypeId);
      message.success(t("expenseTypes.update.success")); 
      getAllExpenseTypes(); // Rafraîchir la liste
    onClose(); // Fermer le modal
    } catch (error) {
      notification.error({
        message: t("employees.crud.form.error.edit"),
        description: error.message,
        role: "alert",
        duration: 3,
    });
  } finally {
    setIsSendForUpdate(true);
}
};

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={
      <h4 style={{
        textAlign: "center",
        fontSize: "20px",
        fontWeight: "bold",
        color: "#333",
        marginBottom: 0 }}>{t("expenseTypes.crud.form.title.modification")}</h4>
    }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose} className="custom-btn-1">
          {t("common.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="depensetype-Form"
          disabled={isLoading}
          className="custom-btn-2"
        >
          {t("common.save")}
        </Button>,
      ]}
      centered={true} 
            styles={{ content: { overflowY: "auto", maxHeight: "75vh", width: "100%" } }}
        >
      <ExpenseTypeForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default EditExpenseTypeModal;

